export default {"src":"/_next/static/image/public/img/functionly-logo.48dc8432516e69df04c4a20ac9c391ec.svg","height":45,"width":255};